import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';

interface AgentSkills {
  id: string; // added to satisfy the resource requirement
  agentId: string;
  skillIds: Array<string>;
}

const agentSkillsResource = createCollectionResource<AgentSkills>({
  name: 'agentSkills',
  endpoint: 'v1/orgs/:orgId/agent-skills/:id',
  observerCreator: emptyObserverCreator,
});

export default agentSkillsResource;
